import { Link, useLocation } from "wouter";
import { Button } from "../components/Button";
import styles from "./NotFoundPage.module.css";

/**
 * /404 — fallback for any unmatched route. Figma node 217:13027.
 *
 * Minimal layout: wordmark navbar, centred 404 + tagline + CTA. No
 * back button — the user landed here via a bad URL, so the CTA takes
 * them to the forecast home instead.
 */
export function NotFoundPage() {
  const [, setLocation] = useLocation();

  return (
    <div className={styles.layout}>
      <nav className={styles.navbar}>
        <Link href="/" className={styles.wordmark} aria-label="Big Wind — home">
          BIGWIND
        </Link>
      </nav>

      <main className={styles.main}>
        <div className={styles.text}>
          <p className={styles.code}>404</p>
          <p className={styles.message}>
            No wind here. This page doesn't exist. Try the forecast instead
          </p>
        </div>
        <Button onClick={() => setLocation("/")}>Go to forecast</Button>
      </main>
    </div>
  );
}
